import React from 'react';

export const PopupContainerTable = ({ children }) => {
  return (
    <div className="defaultRndCancel bg-white text-xs grid-cols-full w-full overflow-x-hidden cursor-auto min-w-[400px]">
      {children}
    </div>
  );
};
